import {
  Divider,
  ListItem,
  ListItemIcon,
  ListItemText,
  makeStyles,
  Theme,
} from "@material-ui/core";
import React, { ComponentType, SVGProps } from "react";
import { SvgIconProps } from "@material-ui/core/SvgIcon";

interface Props {
  label?: string;
  title?: string;
  Icon?: ComponentType<SvgIconProps> | ComponentType<SVGProps<SVGSVGElement>>;
  onClick: () => void;
}

const useStyles = makeStyles((theme: Theme) => ({
  exportImportItem: {
    cursor: "pointer",
    transition: "background-color 150ms ease",
    "&:hover": {
      backgroundColor: theme.palette.background.paper,
    },
  },
  icon: {
    color: theme.palette.primary.main,
  },
}));

export const ExportImportItem = ({ label, title, Icon, onClick }: Props) => {
  const classes = useStyles();
  return (
    <>
      <ListItem className={classes.exportImportItem} onClick={onClick}>
        {Icon && (
          <ListItemIcon>
            <Icon className={classes.icon} />
          </ListItemIcon>
        )}
        <ListItemText primary={label} secondary={title} />
      </ListItem>
      <Divider />
    </>
  );
};
